module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//pet-effect_base_4.png?v=3ac212fd";